module.exports = __webpack_public_path__ + "img/Beginner-6.ffb18694.gif";